if (!customElements.get('collections-filtering')) {
	class CollectionsFiltering extends HTMLElement {
		constructor() {
			super();

			this.form = this.querySelector('form');
			this.button = this.querySelector('button[type="submit"]');
			this.select = this.querySelector('select.dropdown-collection');
			this.input = this.querySelector('input.input-collection');
			this.selects = this.querySelectorAll('select.dropdown-filter');

			this.setupEventListeners();

			// There's no collection dropdown so we either need to populate
			// the filters of the entire store or the single collection chosen
			// (if only one collection has been chosen).
			if (!this.select) {
				this.populateCollectionFilters(true);
			}
		}

		setupEventListeners() {
			this.form.addEventListener('submit', (event) => {
				event.preventDefault();
				window.location = this.form.getAttribute('action');
			});
			this.select?.addEventListener('change', this.onCollectionChange.bind(this));

      // Add event listener for the year select
      const yearSelect = this.querySelector('.filter--year'); 
      const makeSelect = this.querySelector('.filter--make'); 
      const modelSelect = this.querySelector('.filter--model'); 


      if (yearSelect) {
        yearSelect.addEventListener('change', (event) => {
          const selectedYear = event.target.value; // Get the selected year
          setMakeOptions(selectedYear); // Call the function with the selected year
        });
      }

      if (makeSelect) {
        makeSelect.addEventListener('change', (event) => {
          const selectedMake = event.target.value; // Get the selected year
          setModelOptions(selectedMake); // Call the function with the selected year
        });
      }

      if (modelSelect) {
        modelSelect.addEventListener('change', (event) => {
          const selectedModel = event.target.value; // Get the selected year
          setVROptions(selectedModel); // Call the function with the selected year
        });
      }

      
			this.selects.forEach(event => {
				event.addEventListener('change', this.onFilterChange.bind(this));
			});
		}

		constructURL() {
      const collectionUrl = this.select?.value ?? this.input?.value ?? '/pages/find-my-car-result';
      const url = new URL(collectionUrl, window.shopUrl);
  
      // Get the selected values from the dropdowns
      const yearSelect = this.querySelector('.filter--year');
      const makeSelect = this.querySelector('.filter--make');
      const modelSelect = this.querySelector('.filter--model');
      const variantSelect = this.querySelector('.filter--vehicle'); // varirant (vehicle)
  
      const selectedYear = yearSelect?.value;
      const selectedMake = makeSelect?.value;
      const selectedModel = modelSelect?.value;
      const selectedVariant = variantSelect?.value;
  
      // Construct the URL parameters based on the selected values
      if (selectedYear) {
        url.searchParams.set('year', selectedYear);
      }
  
      if (selectedMake) {
        // Only add make if year is present
        if (selectedYear) {
            url.searchParams.set('make', selectedMake);
        }
      }
  
      if (selectedModel) {
        // Only add model if year and make are present
        if (selectedYear && selectedMake) {
            url.searchParams.set('model', selectedModel);
        }
      }
  
      if (selectedVariant) {
        // Only add variant if year, make, and model are present
        if (selectedYear && selectedMake && selectedModel) {
            url.searchParams.set('variant', selectedVariant);
        }
      }
  
      return url.toString();
    }

		setFormUrl(url, background) {
			this.form.setAttribute('action', url);

			// This operation happens on the background
			// where the user should not be notified of loading with spinners
			// etc.
			if (!background) {
				this.button.disabled = false;
			}
		}

		selectRemoveOptions(select) {
			const options = select.querySelectorAll('option:not(.default)');

			options.forEach((option) => {
				select.removeChild(option);
			});

			select.querySelector('option').selected = true;
		}

		onFilterChange(event) {
			const selectedIndex = event.target.dataset.index;

			this.selects.forEach((select) => {
				if (Number(select.dataset.index) <= Number(selectedIndex)) {
					return;
				}

				// this.selectRemoveOptions(select);
				select.disabled = true;
				select.closest('.form-group').classList.add('disabled');
			});

			this.setFormUrl(this.constructURL());

			const url = new URL(this.constructURL());
			url.searchParams.set('view', 'do_not_use');
			this.toggleLoading();

			fetch(url)
				.then((response) => {
					if (!response.ok) {
						throw new Error(response.status);
					}

					return response.text();
				})
				.then((text) => {
					this.toggleLoading();
					const resultsMarkup = new DOMParser().parseFromString(text, 'text/html');

					this.selects.forEach((select) => {
						if (Number(select.dataset.index) <= Number(selectedIndex)) {
							return;
						}

						const options = resultsMarkup.querySelectorAll(`select[data-label="${select.dataset.label}"] option`);
						if (options.length > 0) {
							const availableOptions = Array.from(options).filter(option => Number(option.dataset.count) > 0);
							select.append(...availableOptions);
							select.querySelector('option.default').selected = true;
						}

						if (Number(select.dataset.index) === Number(selectedIndex) + 1) {
							select.disabled = false;
							select.closest('.form-group').classList.remove('disabled');
						}
					});
				})
				.catch((error) => {
					throw error;
				});
		}

		populateCollectionFilters(background = false) {
			this.setFormUrl(this.constructURL(), background);

			const url = new URL(this.constructURL());
			url.searchParams.set('view', 'do_not_use');

			// When we initially populate the filters we don't want
			// to show a loading spinner.
			if (!background) {
				this.toggleLoading();
			}

			fetch(url)
				.then((response) => {
					if (!response.ok) {
						throw new Error(response.status);
					}

					return response.text();
				})
				.then((text) => {
					if (!background) {
						this.toggleLoading();
					} 

					const resultsMarkup = new DOMParser().parseFromString(text, 'text/html');

					this.selects.forEach((select) => {
						const options = resultsMarkup.querySelectorAll(`select[data-label="${select.dataset.label}"] option`);
						if (options.length > 0) {
							select.append(...options);
							select.querySelector('option.default').selected = true;
						}

						if (Number(select.dataset.index) === 1) {
							select.disabled = false;
							select.closest('.form-group').classList.remove('disabled');
						}
					});
				})
				.catch((error) => {
					throw error;
				});
		}

		onCollectionChange() {
			this.selects.forEach((select) => {
				// this.selectRemoveOptions(select);
				select.disabled = true;
				select.closest('.form-group').classList.add('disabled');
			});

			this.populateCollectionFilters();
		}

		toggleLoading() {
			this.classList.toggle('is-loading');
			this.button.classList.toggle('loading');
		}
	}

	customElements.define('collections-filtering', CollectionsFiltering);
}
